import Filter from '@helpers/Filter';
import { useRef } from 'react';

export default function useUrlParams() {
  return useRef(Filter.urlParams(window.location.search)).current;
}
